import React from 'react';
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import LoadingScreen from "./LoadingScreen";

const AuthAdminRoute = () => {
	const { user, role, loading } = useAuth();
    const allowedRoles = ["ADMIN", "OWNER", 'DEV'];

	if (loading) {
		return <LoadingScreen />
	}
    if (!user) {
        return <Navigate to="/login" />;
    }
    if (!role) {
        return <Navigate to="/profile" />;
    }
	return allowedRoles.includes(role) ? <Outlet /> : <Navigate to="/profile" />;
};

export default AuthAdminRoute;
